import PaymentStatus from '../types/paymentStatus.type';
import { Role } from '../components/providers/authProvider';
import { Row } from '../pages/components/interface';
import { Key } from 'react';

export const deleteButtonIsVisible = (role: Role, status: PaymentStatus) =>
  [PaymentStatus.DRAFT, PaymentStatus.PENDING, PaymentStatus.REJECTED, PaymentStatus.POSTPONED].includes(status);
export const disableCheckbox =
  (selectedIds: Key[]) =>
  ({ id, status }: Row) => ({
    disabled: status !== 'PENDING' || (selectedIds.length >= 5 && !selectedIds.includes(id)),
    status,
  });
